import { UUID } from "crypto";

import { useCreateNotificationMutation } from "@services/api/notifications";

interface NotifyRequestAssignedParams {
    loanApplicationId: UUID;
    userAssigned: UUID;
    userId: UUID;
}

export function useNotifyRequestAssigned() {
    const [triggerCreateNotification] = useCreateNotificationMutation();

    const notifyRequestAssigned = async ({ loanApplicationId, userAssigned, userId }: NotifyRequestAssignedParams) => {
        try {
            await triggerCreateNotification({
                type_code: "request.assigned",
                loan_application_id: loanApplicationId,
                user_assigned: userAssigned,
                user_id: userId,
            }).unwrap();
        } catch (error) {
            console.error(`No se pudo crear la notificación de asignación: ${error}`);
        }
    };

    return { notifyRequestAssigned };
}
